import { createContext, useContext, useState, ReactNode } from "react";

interface AircraftContextType {
  selectAircraft: any;
  setSelectedAircraft: (aircraft: any) => void;
  setSelectAircraftId: (id: any) => void;
  clearSelectedAircraft: () => void;
  selectAircraftId: any;
}

// Create a context with a default value
export const AircraftContext = createContext<AircraftContextType>({
  selectAircraft: null,
  selectAircraftId: null,
  setSelectAircraftId: () => {},
  setSelectedAircraft: () => {},
  clearSelectedAircraft: () => {},
});

// Create a provider component
export const AircraftProvider = ({ children }: { children: ReactNode }) => {
  const [selectAircraft, setSelectedAircraft] = useState<string | null>(null);
  const [selectAircraftId, setSelectAircraftId] = useState<any>(null);

  const clearSelectedAircraft = () => {
    setSelectedAircraft(null);
    setSelectAircraftId(null);
  };

  return (
    <AircraftContext.Provider
      value={{
        selectAircraft,
        setSelectedAircraft,
        clearSelectedAircraft,
        setSelectAircraftId,
        selectAircraftId,
      }}
    >
      {children}
    </AircraftContext.Provider>
  );
};

// Custom hook to use the AircraftContext
export const useAircraft = () => useContext(AircraftContext);
